module.exports = __webpack_public_path__ + "img/userDefaultImg.3edae554.jpg";